/**
 * Preferência de música de fundo (navbar). Mesmo padrão de persistência que {@link ./quizSfx.ts}:
 * localStorage + valor em memória; opcionalmente alinhado ao perfil quando a API enviar o campo.
 */

const STORAGE_KEY = 'quizterBackgroundMusicEnabled';
/** Chave antiga (paused=true significava música off). Migrada uma vez para STORAGE_KEY. */
const LEGACY_PAUSED_KEY = 'quizterBgmPaused';

/** When true, background music should play (subject to browser autoplay rules). */
let bgmEnabled = true;

function migrateLegacyPausedKey(): void {
  try {
    if (typeof window === 'undefined') return;
    if (localStorage.getItem(STORAGE_KEY) !== null) return;
    const legacy = localStorage.getItem(LEGACY_PAUSED_KEY);
    if (legacy === null) return;
    const enabled = legacy !== 'true';
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
    localStorage.removeItem(LEGACY_PAUSED_KEY);
  } catch {
    /* ignore */
  }
}

function readStoredPreference(): void {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === null) {
      bgmEnabled = true;
      return;
    }
    bgmEnabled = raw === 'true' || raw === '1';
  } catch {
    bgmEnabled = true;
  }
}

/**
 * Chama uma vez ao iniciar a app (por exemplo em `App`) antes do `AppBackgroundMusicProvider`. Lê localStorage (padrão: música ligada).
 */
export function initAppBgmPreference(): void {
  migrateLegacyPausedKey();
  readStoredPreference();
}

export function getAppBgmEnabled(): boolean {
  return bgmEnabled;
}

/** Atualiza runtime + localStorage (sem API). */
export function setAppBgmEnabledLocal(enabled: boolean): void {
  bgmEnabled = enabled;
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    /* ignore */
  }
}

/** Disparado quando a preferência em memória/localStorage muda vinda do servidor (GET /user/profile). */
export const APP_BGM_PREFERENCE_SYNC_EVENT = 'quizter-app-bgm-preference-sync';

/**
 * Aplica preferência vinda do GET /user/profile (autoritativo quando o servidor envia o campo).
 */
export function applyAppBgmPreferenceFromServer(enabled: boolean): void {
  bgmEnabled = enabled;
  try {
    localStorage.setItem(STORAGE_KEY, enabled ? 'true' : 'false');
  } catch {
    /* ignore */
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(APP_BGM_PREFERENCE_SYNC_EVENT));
  }
}
